export default __webpack_public_path__ + "static/MEDIO_POLLO-484373486f4dc35ebbda283207f617dd.jpg";